export default {
  POPUP: 'popup',
  OVERLAY: 'overlay',
};
